import { render, staticRenderFns } from "./PopupChemSubstanceSearch.vue?vue&type=template&id=2bb654ee&scoped=true"
import script from "./PopupChemSubstanceSearch.vue?vue&type=script&lang=js"
export * from "./PopupChemSubstanceSearch.vue?vue&type=script&lang=js"
import style0 from "./PopupChemSubstanceSearch.vue?vue&type=style&index=0&id=2bb654ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb654ee",
  null
  
)

export default component.exports